import { standard } from '../../constants';

export default {
  ...standard('CREATE', 'players'),
  ...standard('DELETE', 'players'),
  ...standard('GET', 'players'),
  ...standard('UPDATE', 'players'),
};



// WEBPACK FOOTER //
// ./src/modules/players/constants.js